import { makeStyles } from "@material-ui/core/styles";
import theme from "theme";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: 500,
    alignItems: "center",
    margin: theme.spacing(3),
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default useStyles;
